import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import LocationPageLayer from "../components/LocationLayerPage";
// import FormPageLayer from "../components/FormPageLayer";



const LocationPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Category Form" header="Location " />

        {/* FormPageLayer */}
        <LocationPageLayer />


      </MasterLayout>

    </>
  );
};

export default LocationPage;
